/* ============================================================
   PRILU — shared luxe behaviour
   Reveal-on-scroll via IntersectionObserver. Idempotent
   singleton so multiple sections can each request it safely.
   Respects prefers-reduced-motion and the Shopify theme editor.
   ============================================================ */
(function () {
  if (window.__priluLuxeReveal) return;
  window.__priluLuxeReveal = true;

  var reduce =
    window.matchMedia &&
    (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      // Skip scroll-reveal on mobile — reveal everything immediately
      window.matchMedia('(max-width: 749px)').matches);

  function reveal(el) {
    el.classList.add('is-revealed');
  }

  function init(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-reveal]:not(.is-revealed)');

    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(els, reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    Array.prototype.forEach.call(els, function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-scan when a section is (re)loaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
